<template>
  <div>
    <div>
      <h1 class="h2 mt-4">Szerződő adatai</h1>
      <div class="row">
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="szerzodo_neve-prepend">
                Szerződő neve: <span class="text-danger">*</span>
                <span
                  class="info"
                  id="szerzodo_neve-tooltip"
                  data-toggle="tooltip"
                  data-placement="right"
                  title=""
                  >?</span
                >
              </span>
            </div>
            <input
              type="text"
              class="form-control"
              id="szerzodo_neve"
              name="szerzodo_neve"
              v-model="companyName"
              aria-label="Szerződő neve"
              aria-describedby="szerzodo_neve-prepend"
              :class="classes"
            />
          </div>
          <small id="szerzodo_neve-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
        <ValidationProvider
          rules="required|adoszam"
          v-slot="{errors, classes}"
          class="col-md-6 mb-3"
        >
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="adoszam-prepend"
                >Adószám: <span class="text-danger">*</span></span
              >
            </div>
            <input
              v-maska="'########-#-##'"
              type="text"
              class="form-control"
              id="adoszam"
              name="adoszam"
              v-model="companyVat"
              aria-label="Adószám"
              aria-describedby="adoszam-prepend"
              :class="classes"
            />
          </div>
          <small id="adoszam-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="sz_irszam-prepend"
                >Irányítószám: <span class="text-danger">*</span></span
              >
            </div>
            <div class="flex-grow-1">
              <ValidationProvider rules="required" v-slot="{errors}">
                <Select2
                  name="sz_irszam"
                  v-model="companyPostalCode"
                  :options="zipCodes"
                  :settings="{selectionCssClass: 'w-full'}"
                />
                <small id="sz_irszam-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="sz_telepules-prepend"
                >Település neve: <span class="text-danger">*</span></span
              >
            </div>

            <div class="flex-grow-1" v-if="cityNames.length > 1">
              <ValidationProvider rules="required" v-slot="{errors}">
                <Select2
                  name="sz_telepules"
                  v-model="companyCity"
                  :options="cityNames"
                  :settings="{selectionCssClass: 'w-full'}"
                />
                <small id="sz_telepules-error" class="text-danger input-alert">{{
                  errors[0]
                }}</small>
              </ValidationProvider>
            </div>
            <ValidationProvider v-else rules="required" v-slot="{errors}">
              <input
                type="text"
                class="form-control"
                id="sz_telepules"
                name="sz_telepules"
                readonly
                :value="companyCity"
                aria-label="Település neve"
                aria-describedby="sz_telepules-prepend"
              />
              <small id="sz_telepules-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <ValidationProvider rules="required" v-slot="{errors, classes}">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="sz_utcahsz-prepend"
                >Utca, házszám: <span class="text-danger">*</span></span
              >
            </div>
            <input
              type="text"
              class="form-control"
              id="sz_utcahsz"
              name="sz_utcahsz"
              v-model="companyAddress"
              aria-label="Utca, házszám"
              aria-describedby="sz_utcahsz-prepend"
              :class="classes"
            />
          </div>
          <small id="sz_utcahsz-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

      <div class="form-group row mb-3">
        <label for="sz_email" class="col-sm-4">
          Szerződő e-mail címe: <span class="text-danger">*</span>
        </label>
        <ValidationProvider
          :rules="{required: true, email: true}"
          vid="sz_email"
          v-slot="{errors, classes}"
          class="col-sm-8"
        >
          <input
            type="email"
            class="form-control"
            id="sz_email"
            name="sz_email"
            v-model="companyEmail"
            :class="classes"
          />
          <small id="sz_email-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group row">
        <label class="col-sm-4" for="sz_telefon"
          >Szerződő telefonszáma:<span class="text-danger">*</span></label
        >
        <ValidationProvider rules="max:2|required" v-slot="{errors, classes}" class="col-sm-3 mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="sz_telefon_korzet_prepend">+36</span>
            </div>
            <input
              type="number"
              min="1"
              max="99"
              class="form-control"
              id="sz_telefon_korzet"
              name="sz_telefon_korzet"
              aria-label="Körzetszám"
              aria-describedby="sz_telefon_korzet_prepend"
              v-model.number="companyPhoneArea"
              :class="classes"
            />
          </div>
          <small id="sz_telefon_korzet-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
        <ValidationProvider
          rules="min:6|max:7|required"
          v-slot="{errors, classes}"
          class="col-sm-5"
        >
          <input
            type="number"
            class="form-control"
            id="sz_telefon"
            name="sz_telefon"
            v-model="companyPhone"
            :class="classes"
          />
          <small id="sz_telefon-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
    </div>

    <div>
      <h1 class="h2 mt-4">Biztosított adatai</h1>
      <div class="form-group row mb-3">
        <label class="col-sm-4">A szerződő személye megegyezik a biztosítottal?</label>
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="szerzodo_biztositott"
              id="szerzodo_biztositott_igen"
              :value="1"
              v-model="companyIsTheInsured"
            />
            <label class="form-check-label" for="szerzodo_biztositott_igen">
              Igen
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="szerzodo_biztositott"
              id="szerzodo_biztositott_nem"
              :value="0"
              v-model="companyIsTheInsured"
            />
            <label class="form-check-label" for="szerzodo_biztositott_nem">
              Nem
            </label>
          </div>
        </div>
      </div>
      <div v-show="!companyIsTheInsured">
        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="biztositott_neve_prepend"
                  >Biztosított neve: <span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="biztositott_neve"
                name="biztositott_neve"
                :value="companyName"
                aria-label="Biztosított neve"
                aria-describedby="biztositott_neve_prepend"
                :class="classes"
                v-if="companyIsTheInsured"
              />
              <input
                type="text"
                class="form-control"
                id="biztositott_neve"
                name="biztositott_neve"
                v-model="insuredName"
                aria-label="Biztosított neve"
                aria-describedby="biztositott_neve_prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="biztositott_neve-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="b_irszam-prepend"
                  >Irányítószám: <span class="text-danger">*</span></span
                >
              </div>

              <div class="flex-grow-1" v-if="!companyIsTheInsured">
                <ValidationProvider rules="required" v-slot="{errors}">
                  <Select2
                    name="b_irszam"
                    v-model="insuredPostalCode"
                    :options="zipCodes"
                    :settings="{selectionCssClass: 'w-full'}"
                  />
                  <small id="sz_irszam-error" class="text-danger input-alert">{{
                    errors[0]
                  }}</small>
                </ValidationProvider>
              </div>
              <ValidationProvider v-else rules="required" v-slot="{errors}">
                <input
                  type="text"
                  class="form-control"
                  id="b_irszam"
                  name="b_irszam"
                  :value="companyPostalCode"
                  aria-label="Irányítószám"
                  aria-describedby="b_irszam-prepend"
                />
                <small id="sz_irszam-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="b_telepules-prepend"
                  >Település neve: <span class="text-danger">*</span></span
                >
              </div>

              <template v-if="!companyIsTheInsured">
                <div class="flex-grow-1" v-if="insuredCityNames.length > 1">
                  <ValidationProvider rules="required" v-slot="{errors}">
                    <Select2
                      name="b_telepules"
                      v-model="insuredCity"
                      :options="insuredCityNames"
                      :settings="{selectionCssClass: 'w-full'}"
                    />
                    <small id="sz_irszam-error" class="text-danger input-alert">{{
                      errors[0]
                    }}</small>
                  </ValidationProvider>
                </div>
                <ValidationProvider v-else rules="required" v-slot="{errors}">
                  <input
                    type="text"
                    class="form-control"
                    id="b_telepules"
                    name="b_telepules"
                    readonly
                    :value="insuredCity"
                    aria-label="Település neve"
                    aria-describedby="b_telepules-prepend"
                  />
                  <small id="sz_irszam-error" class="text-danger input-alert">{{
                    errors[0]
                  }}</small>
                </ValidationProvider>
              </template>
              <input
                type="text"
                class="form-control"
                id="b_telepules"
                name="b_telepules"
                :value="companyCity"
                aria-label="Település neve"
                aria-describedby="b_telepules-prepend"
                v-else
              />
            </div>
          </div>
        </div>

        <div class="mb-3">
          <ValidationProvider rules="required" v-slot="{errors, classes}">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="b_utcahsz-prepend"
                  >Utca, házszám: <span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="b_utcahsz"
                name="b_utcahsz"
                v-model="insuredAddress"
                aria-label="Utca, házszám"
                aria-describedby="b_utcahsz-prepend"
                :class="classes"
                v-if="!companyIsTheInsured"
              />
              <input
                type="text"
                class="form-control"
                id="b_utcahsz"
                name="b_utcahsz"
                v-model="companyAddress"
                aria-label="Utca, házszám"
                aria-describedby="b_utcahsz-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="b_utcahsz-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from 'v-select2-component';
import {mapFields} from 'vuex-map-fields';

export default {
  components: {
    Select2,
  },
  data() {
    return {
      cityNames: [],
      insuredCityNames: [],
    };
  },
  computed: {
    ...mapFields([
      'cities',

      'companyName',
      'companyVat',
      'companyPostalCode',
      'companyCity',
      'companyAddress',
      'companyEmail',
      'companyPhoneArea',
      'companyPhone',

      'companyIsTheInsured',

      'insuredName',
      'insuredPostalCode',
      'insuredCity',
      'insuredAddress',
    ]),
    zipCodes: {
      get() {
        return Object.keys(this.cities);
      },
    },
  },
  watch: {
    companyPhoneArea: function(newVal) {
      if (newVal > 99) this.companyPhoneArea = 99;
      if (newVal < 0) this.companyPhoneArea = 1;
    },
    companyPostalCode: function() {
      const zipCodeList = Object.keys(this.cities);
      if (
        zipCodeList.length === 0 ||
        (zipCodeList.length > 0 && !zipCodeList.includes(this.companyPostalCode))
      )
        return (this.cityNames = []);

      const zipData = this.cities[this.companyPostalCode];

      if (!zipData) return (this.cityNames = []);

      this.cityNames =
        typeof zipData.telepules === 'string'
          ? [zipData.telepules]
          : Object.values(zipData.telepules);

      if (this.cityNames.length === 1) {
        this.companyCity = this.cityNames[0];
      } else {
        if (this.companyCity !== '') this.companyCity = '';
      }
    },
    insuredPostalCode: function() {
      const zipCodeList = Object.keys(this.cities);
      if (
        zipCodeList.length === 0 ||
        (zipCodeList.length > 0 && !zipCodeList.includes(this.insuredPostalCode))
      )
        return (this.insuredCityNames = []);

      const zipData = this.cities[this.insuredPostalCode];

      if (!zipData) return (this.insuredCityNames = []);

      this.insuredCityNames =
        typeof zipData.telepules === 'string'
          ? [zipData.telepules]
          : Object.values(zipData.telepules);

      if (this.insuredCityNames.length === 1) {
        this.insuredCity = this.insuredCityNames[0];
      } else {
        if (this.insuredCity !== '') this.insuredCity = '';
      }
    },
  },
};
</script>

<style lang="scss">
.select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container .select2-selection--single {
  height: 38px !important;
  border-color: #ced4da;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.select2-selection__arrow {
  height: 38px !important;
}
</style>
